import { MetricsDaemon } from './MetricsDaemon';
import { getGlobal } from '../getGlobal';
import enviro from 'enviro';
function runMetricsDaemon() {
  const daemonInstance = MetricsDaemon.instance();
  daemonInstance.run();
  const global = getGlobal();
  if (!enviro.deployed()) {
    global.flushMetricsJs = () => daemonInstance.flush();
  }
  return daemonInstance;
}
export { runMetricsDaemon };